module.exports = __webpack_public_path__ + "img/04.036f73a8.png";